export default from './BuyerRegistrationForm';



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRegistrationForm/index.js